module.exports = __webpack_public_path__ + "img/samson.5df3f7b8.png";